import React, { useState, useRef, useEffect } from "react";
import "./suppliers.css";

// components imports
import SupplierTable from "../../../Components/BoltTable/BoltTable";
import Confirm from "../../../Components/Popups/Confirm";
import Tooltip from "../../../Components/Tooltip/Tooltip";

// apis imports
import {
  getAllSuppliersList,
  deleteSupplier,
} from "../../../services/warehouse.services";
// library imports
import { MdOutlineCancel } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { FcPlus } from "react-icons/fc";
import EditSupplier from "./Components/EditSupplier/EditSupplier";
import AddSupplier from "./Components/AddSupplier/AddSupplier";
import { useTranslation } from "react-i18next";

const Suppliers = ({ snack, setSnack }) => {
  const { t } = useTranslation(["inventory", "common"]);
  const [addSupplierOpen, setAddSupplierOpen] = useState(false);
  const [editSupplierOpen, setEditSupplierOpen] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [deleteLoader, setdeleteLoader] = useState(false);

  const [suppliers, setSuppliers] = useState([]);

  const columns = [
    {
      id: 1,
      label: t("suppliers.name"),
      render: (row) => <>{row?.name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("suppliers.address"),
      render: (row) => <>{row?.address ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("suppliers.website"),
      render: (row) => <>{row?.website ?? "-"}</>,
      width: "200px",
    },
    {
      id: 4,
      label: t("suppliers.email"),
      render: (row) => <>{row?.email ?? "-"}</>,
      width: "200px",
    },
    {
      id: 5,
      label: t("suppliers.phone"),
      render: (row) => <>{row?.phone ?? "-"}</>,
      width: "200px",
    },
    {
      id: 6,
      label: t("suppliers.action"),
      render: (row) => (
        <>
          <div className="table_action__wrap">
            <Tooltip title={t("suppliers.editUserDetails")}>
              <div
                className="table_action__btn"
                onClick={() => setEditSupplierOpen(row)}
              >
                <FaRegEdit size={10} />
                {t("common:actions.edit")}
              </div>
            </Tooltip>

            <Tooltip title={t("suppliers.deleteUser")}>
              <div
                className="table_action__btn"
                onClick={() => setConfirmDelete(row)}
              >
                <MdOutlineCancel size={10} />
                {t("common:actions.delete")}
              </div>
            </Tooltip>
          </div>
        </>
      ),
      width: "200px",
    },
  ];

  const fetchAllSuppliers = async (page, perPage, filter) => {
    const response = await getAllSuppliersList(page, perPage, filter);

    if (!response.error) {
      setSuppliers(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const handleDeleteRequest = async (data) => {
    if (data.id) {
      setdeleteLoader(true);
      const response = await deleteSupplier(data.id);

      if (!response.error && response?.data?.success) {
        setSuppliers((prevSuppliers) => {
          return {
            ...prevSuppliers,
            data: prevSuppliers?.data?.filter((d) => d?.id != data?.id),
          };
        });
        setdeleteLoader(false);
        setConfirmDelete(false);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("suppliers.requestDeletedSuccessfully"),
            severity: "success",
          };
        });
      } else {
        setdeleteLoader(false);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text:
              response?.error?.response?.data?.message ||
              t("suppliers.couldntCancelThisRequest"),
            severity: "error",
          };
        });
      }
    }
  };
  return (
    <>
      <Confirm
        open={confirmDelete}
        setOpen={setConfirmDelete}
        handleConfirm={() => handleDeleteRequest(confirmDelete)}
        text={t("suppliers.deleteThisSupplier")}
        loader={deleteLoader}
      />

      <div className="supplier_header">
        <div>
          <span className="supplier_hdrheading"></span>
        </div>
        <div className="supplier_buttonsWrapper">
          <div onClick={() => setAddSupplierOpen(true)}>
            <div className="supplier_hdraddprod">
              <FcPlus size={10} />
              <span>{t("suppliers.addSupplierCaps")}</span>
            </div>
          </div>
        </div>
      </div>

      <div>
        <SupplierTable
          tableTitle={t("suppliers.suppliers")}
          tableId="supplierTableforProduct"
          message={t("suppliers.noSupplierAvailableToDisplay")}
          searchPlaceHolder={t("suppliers.searchSuppliers")}
          columns={columns}
          data={suppliers}
          getAllData={fetchAllSuppliers}
          refresh={refresh}
        />
      </div>

      <AddSupplier
        open={addSupplierOpen}
        setOpen={setAddSupplierOpen}
        setRefresh={setRefresh}
        setSnack={setSnack}
      />
      <EditSupplier
        open={editSupplierOpen}
        setOpen={setEditSupplierOpen}
        setSuppliers={setSuppliers}
        setSnack={setSnack}
      />
    </>
  );
};
export default Suppliers;
